import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IInventur } from '../_interfaces/inventur';
import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class InventurService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'inventurdatum', type: 'DateTimeOffset'},
    {name: 'rueckgemeldet', type: 'DateTimeOffset'},
    {name: 'zustand', type: 'string'},
    {name: 'bemerkung', type: 'string'},
    {name: 'dienstleisterId', type: 'int'},
    {name: 'behaelterId', type: 'int'},
    {name: 'interneBehaelterNummer', type: 'string'},
    {name: 'behaelterNummer', type: 'string'},
    {name: 'verfuegbarkeitsstatus', type: 'string'},
    {name: 'behaeltervolumen', type: 'string'}, // Liter
    {name: 'hersteller', type: 'string'},
    {name: 'baujahr', type: 'DateTimeOffset'},
    {name: 'tankfarbe', type: 'string'},
    {name: 'lagerungsart', type: 'string'},
    {name: 'anlagenart', type: 'string'},
    {name: 'tUEVDatum', type: 'DateTimeOffset'},
    {name: 'letzteBewegung', type: 'DateTimeOffset'},
    
    { name: 'behaeltergroesse', type: 'string' },
    { name: 'faelligkeit', type: 'DateTimeOffset' },
    { name: 'letzteInnerePruefung', type: 'DateTimeOffset' },
    { name: 'letzteAeusserePruefung', type: 'DateTimeOffset' },
    { name: 'umbauNummer', type: 'string' },
    { name: 'umbauBaujahr', type: 'DateTimeOffset' },
    { name: 'umbauHersteller', type: 'string' },
    { name: 'vorhanden', type: 'bool' },
    { name: 'nrVersorgungsunternehmen', type: 'string' },
    { name: 'dispokennzeichen_1', type: 'bool' },
    { name: 'dispokennzeichen_2', type: 'bool' },
    { name: 'dispokennzeichen_3', type: 'bool' },
    { name: 'dispokennzeichen_4', type: 'bool' },
    { name: 'dispokennzeichen_5', type: 'bool' },
    { name: 'dispokennzeichen_6', type: 'bool' },

    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'summary', type: 'string'}
  ];
    
  getInventurenCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ inventuren: IInventur[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'inventuren?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          //return { inventuren: <IInventur[]>response.body, pagination: <IPagination>JSON.parse(response.headers.get('x-pagination')) };
          const returnValue = { inventuren: <IInventur[]>response.body, pagination: /*<IPagination>JSON.parse(response.headers.get('x-pagination'))*/this.getDummyPagination((<any[]>response.body).length) };
          console.log("inventurService.getInventurenCollection() returnValue:", returnValue);
          return returnValue;
        }), catchError(this.handleError))
  }

  getInventur(id: number): Observable<IInventur> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializeInventur());
      //   observer.complete();
      // })
      return of(this.initializeInventur());
    }

    return this.httpClient.get<IInventur>(this.apiBaseUrl + 'inventuren?inventur=' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) =>
      //response
      {
        return response[0];
      }
      ), catchError(this.handleError));
  }

  saveInventur(inventur: IInventur): Observable<IInventur> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(inventur); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("InventurService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("InventurService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (inventur.id === 0) {
      return this.createInventur(/*inventur*/itemToSave);
    }

    return this.updateInventur(/*inventur*/itemToSave)

  }

  updateInventur(inventur: IInventur): Observable<IInventur> {

    return this.httpClient.put<IInventur>(this.apiBaseUrl + 'inventuren'/*/' + inventur.id*/, inventur, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }
  
  deleteInventur(id: number) {

    return this.httpClient.delete(this.apiBaseUrl + 'inventuren/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createInventur(inventur: IInventur): Observable<IInventur> {
    return this.httpClient.post<IInventur>(this.apiBaseUrl + 'inventuren', inventur, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }

  initializeInventur(): IInventur {
    return {
      id: 0,
      inventurdatum: null,
      rueckgemeldet: null,
      zustand: '',
      bemerkung: '',
      dienstleisterId: 0,
      behaelterId: 0,
      interneBehaelterNummer: '',
      behaelterNummer: '',
      verfuegbarkeitsstatus: '',
      behaeltervolumen: '', // Liter
      hersteller: '',
      baujahr: null,
      tankfarbe: '',
      lagerungsart: '',
      anlagenart: '',
      tUEVDatum: null,
      letzteBewegung: null,

      behaeltergroesse: '',
      faelligkeit: null,
      letzteInnerePruefung: null,
      letzteAeusserePruefung: null,
      umbauNummer: '',
      umbauBaujahr: null,
      umbauHersteller: '',
      vorhanden: false,
      nrVersorgungsunternehmen: '',
      dispokennzeichen_1: false,
      dispokennzeichen_2: false,
      dispokennzeichen_3: false,
      dispokennzeichen_4: false,
      dispokennzeichen_5: false,
      dispokennzeichen_6: false,

      createdBy: '',
      created: '',
      modifiedBy: '',
      modified: '',
      rowVersion: '',
      summary: '',

      inventurFotos: [],
    };
  }


}
